var _a;
export var UndoFormReason;
(function (UndoFormReason) {
    UndoFormReason["wrongClient"] = "wrongClient";
    UndoFormReason["wrongAppointment"] = "wrongAppointment";
    UndoFormReason["arrivedLate"] = "arrivedLate";
})(UndoFormReason || (UndoFormReason = {}));
export var UndoFormReasonLabels = (_a = {},
    _a[UndoFormReason.wrongClient] = 'Wrong client',
    _a[UndoFormReason.wrongAppointment] = 'Wrong appointment',
    _a[UndoFormReason.arrivedLate] = 'Patient showed up late',
    _a);
